/**
 * @components timetree
 * @author 陈恩浩
 */

import React, { Component } from 'react'
import Swiper from 'swiper'

import 'src/static/swiper/swiper.css'
import './index.scss'

class TimeTree extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    new Swiper('.swiper-container', {
      slidesPerView: 5,
      freeMode: true,
      centerInsufficientSlides: true,
      navigation: {
        //左右分页
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
  }

  render() {
    let treeList = [
      {
        time: 2005,
        content:
          '哈兔中文成为杭州师范大学外国语学院实践教学基地哈兔中文成为杭州师范大学外国语学.',
      },
      {
        time: 2005,
        content:
          '哈兔中文成为杭州师范大学外国语学院实践教学基地哈兔中文成为杭州师范大学外国语学.',
      },
      {
        time: 2005,
        content:
          '哈兔中文成为杭州师范大学外国语学院实践教学基地哈兔中文成为杭州师范大学外国语学.',
      },
      {
        time: 2005,
        content:
          '哈兔中文成为杭州师范大学外国语学院实践教学基地哈兔中文成为杭州师范大学外国语学.',
      },
      {
        time: 2005,
        content:
          '哈兔中文成为杭州师范大学外国语学院实践教学基地哈兔中文成为杭州师范大学外国语学.',
      },
      {
        time: 2005,
        content:
          '哈兔中文成为杭州师范大学外国语学院实践教学基地哈兔中文成为杭州师范大学外国语学.',
      },
    ]
    return (
      <div className="time-tree">
        <div className="swiper-container">
          {/* <!-- Additional required wrapper --> */}
          <div className="swiper-wrapper">
            {/* <!-- Slides --> */}
            {treeList.map((item, index) => (
              <div className="swiper-slide" key={'treeList-' + index}>
                <div
                  className={
                    index % 2 === 0 ? 'tree-content-top' : 'tree-time-top'
                  }
                >
                  {index % 2 === 0 ? item.content : item.time}
                </div>
                <div className="tree-line"></div>
                <div
                  className={
                    index % 2 === 1 ? 'tree-content-bottom' : 'tree-time-bottom'
                  }
                >
                  {index % 2 === 1 ? item.content : item.time}
                </div>
              </div>
            ))}
          </div>
          {/* <!-- If we need navigation buttons --> */}
          <div className="swiper-button-prev"></div>
          <div className="swiper-button-next"></div>
        </div>
      </div>
    )
  }
}

export default TimeTree
